import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

const SVInvoiceReport = ({ filter, groupName }: { filter: any, groupName: string | null }) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>; loading: boolean });
  const [openSubModel, setOpenSubModel] = useState({ open: false, name: "", index: 0 } as { open: boolean, name: string, index: number });
  const dt = useRef<any>(null);
  const toast = useRef<any>(null);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
  const DateFormat = loginObj.date_Format;

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Sub Vendor Invoice Report</h5>
    </div>
  );

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const mappedFilter = {
      FromDate: filter?.fromDate,
      ToDate: filter?.ToDate,
      Company_ID: filter?.company_ID ?? null,
      Group_ID: filter?.company_Group_ID ?? null,
    };
    const response = await Fetch("Report_Timesheet/getSVInvoiceAddedCount", "GET", null, `filter=${JSON.stringify(mappedFilter)}`, null);
    if (response) {
      const data: Array<any> = await response.json();
      setTableData({ tableData: data, loading: false });
    }
  };

  useEffect(() => {
    loadTableData();
  }, [filter]);

  const isGroupWise = filter?.company_Type === "Company Group Wise";

  return (
    <>
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        resizableColumns
        showGridlines
        columnResizeMode="expand"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        ref={dt}
        size="small"
        stripedRows
        scrollable
        scrollHeight="70vh"
        value={tableData.tableData}
        header={header}
        loading={tableData.loading}
      >
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
        {isGroupWise ? <Column field="company_Name" header={`Company Name of ${groupName || ""}`} /> : <Column field="company_Name" header="Company" />}
        <Column field="totalPOCount" header="No of PO" footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.totalPOCount || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="addedByInHouse" header="No of SV Invoice Uploaded By  InHouse" body={(rowData: any, options: any) => <p className={(rowData.addedByInHouse > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "addedByInHouseList", index: options.rowIndex })}>{rowData.addedByInHouse}</p>} headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.addedByInHouse || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="addedBySV" header="No of SV Invoice Uploaded By SV Account" body={(rowData: any, options: any) => <p className={(rowData.addedBySV > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "addedBySVList", index: options.rowIndex })}>{rowData.addedBySV}</p>} headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.addedBySV || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
      </DataTable>
      <Dialog visible={openSubModel.open} style={{ width: '80vw' }} header={<p>Sub Table</p>} modal className="p-fluid" onHide={() => setOpenSubModel({ open: false, name: "", index: 0 })}>
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          resizableColumns
          showGridlines
          columnResizeMode="expand"
          exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
          size="small"
          stripedRows
          scrollable
          scrollHeight="70vh"
          value={(tableData.tableData[openSubModel.index] || {})[openSubModel.name]}
        >
          <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
          <Column field="invoiceNO" header="#Invoice" />
          <Column field="consultant_Name" header="Consultant Name" />
          <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat, true)} />
          <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat, true)} />
          <Column field="workHours" header="Work Hours" body={(rowData: any) => <p>{Number(rowData.workHours || "0") + Number(rowData.overlapWorkHours || "0")}</p>} />
          <Column field="isVerfied" header="Status" />
          <Column field="paymentStatus" header="Payment Status" />
        </DataTable>
      </Dialog>
      <Toast ref={toast} />
    </>
  );
};

export default SVInvoiceReport;
